module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-regal-06.d6aa0bc6.jpeg";